/**
 * Footer Component
 * Simple footer with copyright and version info
 */

import React from 'react';
import { Box, Typography, Link } from '@mui/material';
import branding from '../../config/branding';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <Box
      component="footer"
      sx={{
        py: 2,
        px: 3,
        mt: 6,
        backgroundColor: 'background.paper',
        borderTop: (theme) => `1px solid ${theme.palette.divider}`,
      }}
    >
      <Typography variant="body2" color="text.secondary" align="center">
        © {currentYear}{' '}
        <Link color="inherit" href="/" underline="hover">
          {branding.appCopyright}
        </Link>
        {' · '}
        {branding.appDescription}
        {' · Construído por: DKMA · '}
        {/*
          A versão vem de `__APP_VERSION__`, que o Vite carimba a partir do package.json no
          momento do build. Antes vinha de `VITE_APP_VERSION`, que os scripts de atualização
          gravam no `.env` mas o build em contêiner nunca recebe (não há `ARG` para ela no
          Dockerfile) — por isso a produção exibia "dev". O `import.meta.env` continua tendo
          precedência, para quem quiser fixar um rótulo próprio.
        */}
        {import.meta.env.VITE_APP_VERSION || __APP_VERSION__}
      </Typography>
    </Box>
  );
};

export default Footer;
